import { Box, Container, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PageHero from '../components/common/PageHero';
import InquiryForm from '../components/forms/InquiryForm';

const trustItems = [
  { icon: CheckCircleOutlineIcon, label: 'Kostenlos & unverbindlich' },
  { icon: AccessTimeIcon, label: 'Antwort in 24 Stunden' },
  { icon: StarBorderIcon, label: '15+ Jahre Erfahrung' },
  { icon: LockOutlinedIcon, label: 'Ihre Daten sind sicher' },
];

export default function Anfrage() {
  const [searchParams] = useSearchParams();
  const isJobApplication = searchParams.get('type') === 'job';

  return (
    <>
      <Helmet>
        <title>{isJobApplication ? 'Bewirb dich jetzt' : 'Anfrage senden'} — Süd Ausbau GmbH</title>
        <meta name="description" content={isJobApplication
          ? "Bewirb dich jetzt bei Süd Ausbau GmbH. Wir freuen uns auf deine Bewerbung."
          : "Senden Sie uns Ihre Projektanfrage. Kostenlose Beratung und unverbindliches Angebot für Innenausbau, Umbau und Sanierung."
        } />
        <link rel="canonical" href="https://sued-ausbau.de/anfrage" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sued-ausbau.de/anfrage" />
        <meta property="og:title" content={`${isJobApplication ? 'Bewirb dich jetzt' : 'Anfrage senden'} — Süd Ausbau GmbH`} />
        <meta property="og:description" content={isJobApplication
          ? "Bewirb dich jetzt bei Süd Ausbau GmbH. Wir freuen uns auf deine Bewerbung."
          : "Senden Sie uns Ihre Projektanfrage. Kostenlose Beratung und unverbindliches Angebot für Innenausbau, Umbau und Sanierung."
        } />
        <meta property="og:image" content="https://sued-ausbau.de/og-preview.png" />
      </Helmet>

      <PageHero
        overline={isJobApplication ? 'Karriere' : 'Kontakt'}
        title={isJobApplication ? 'Bewirb dich jetzt' : 'Ihre Anfrage an uns'}
        description={isJobApplication ? undefined : 'Beschreiben Sie Ihr Projekt — wir melden uns innerhalb von 24 Stunden.'}
      />

      {/* Trust signals strip — only for project inquiries */}
      {!isJobApplication && (
        <Box sx={{ bgcolor: '#F7F5F0', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
          <Container maxWidth="md">
            <Stack
              direction={{ xs: 'grid', sm: 'row' }}
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(4, 1fr)' },
                gap: 0,
                py: { xs: 2.5, sm: 2 },
              }}
            >
              {trustItems.map(({ icon: Icon, label }) => (
                <Box
                  key={label}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: { xs: 1.5, sm: 2 },
                    py: { xs: 1, sm: 0 },
                    borderRight: { sm: '1px solid rgba(0,0,0,0.08)' },
                    '&:last-child': { borderRight: 'none' },
                  }}
                >
                  <Icon sx={{ color: '#B8A06E', fontSize: 20, flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#3D4A5C', lineHeight: 1.3 }}>
                    {label}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Container>
        </Box>
      )}

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          <InquiryForm />
        </Container>
      </Box>
    </>
  );
}
